import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=0484701b&scoped=true&"
import script from "./resources.vue?vue&type=script&lang=js&"
export * from "./resources.vue?vue&type=script&lang=js&"
import style0 from "./resources.vue?vue&type=style&index=0&id=0484701b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484701b",
  null
  
)

export default component.exports